import { InformationPage } from "../../../common/components/informationPage/InformationPage";

import { Link } from "../../../common/components/Link";
import BulkATCPopupContext from "../../../BulkATCPopup/components/BulkATCPopupContext";
import { Permission, userHasPermission } from "../../../utils/permissions";
import { IMG_EMPTY_CART } from "../../../utils/url/staticResources";
import { Button } from "~/common/components/Button/Button";
import { useTranslation } from "react-i18next";
import { HOMEPAGE } from "~/utils/url/staticUrls";
import { QuickEntryPopup } from "~/QuickEntryPopup/components/QuickEntryPopup";
import { userIsCustomer } from "~/utils/roles";
import { useState } from "react";

export const EmptyCartPage = () => {
  const { t } = useTranslation();
  const [isQuickEntryOpen, setQuickEntryOpen] = useState(false);

  const canUseBulkUpload = userHasPermission(Permission.BULK_UPLOAD);

  const isUserCustomer = userIsCustomer();

  return (
    <InformationPage.CenterContents className={"pb-30"}>
      <InformationPage.Title>{t("page.cart.empty.title")}</InformationPage.Title>
      <InformationPage.Image src={IMG_EMPTY_CART} />
      {isUserCustomer && (
        <InformationPage.Subtitle className={"my-0 mt-60"}>{t("page.cart.empty.subtitle")}</InformationPage.Subtitle>
      )}
      {canUseBulkUpload && (
        <div className={"mt-30"}>
          <BulkATCPopupContext>
            {({ openPopup }) => (
              <Button onClick={openPopup} data-test-id={"btn-bulk-upload"}>
                {t("page.cart.empty.btn.bulk")}
              </Button>
            )}
          </BulkATCPopupContext>
        </div>
      )}
      {!isUserCustomer && !canUseBulkUpload && (
        <div>
          <Button onClick={() => setQuickEntryOpen(true)}>{t("page.cart.b2c.process.step.1")}</Button>
          {isQuickEntryOpen && <QuickEntryPopup onClose={() => setQuickEntryOpen(false)} />}
        </div>
      )}

      <Link className={"mt-3"} href={HOMEPAGE} data-test-id={"btn-home"}>
        {t("page.cart.empty.btn.back")}
      </Link>
    </InformationPage.CenterContents>
  );
};
